// @dynamic-i18n-keys
// deviation.details.*
import React from 'react';
import { useTranslation } from 'react-i18next';
import defaultStyles from './Default.scss';

export interface Props {
  name: string;
  value: React.ReactNode;
  transPrefix?: string;
}

export const DetailItem: React.FC<Props> = ({ name, value, transPrefix = '' }) => {
  const { t } = useTranslation();

  if (!value) {
    return null;
  }

  // there are a metric ton of exif keys, so for sake of
  // sanity anything untranslated should just show the raw key name
  const translatedKey = t(`deviation.details.${transPrefix}${name.replace(' ', '')}`, {
    defaultValue: name,
  });

  return (
    <div className={defaultStyles['detail-item']}>
      <div className={defaultStyles['detail-key']}>{translatedKey}</div>
      <div>{value}</div>
    </div>
  );
};
DetailItem.displayName = 'DetailItem';

export default DetailItem;
